import { TransferCandidate } from '../../../budget/project-import/types'

/**
 * Validates budget has required fields
 * @param budget - Budget to validate
 * @returns True if valid
 * @throws Error with field name if missing
 * @example
 * validateBudgetFields(budget) // throws "Missing field: name"
 */
export const validateBudgetFields = (budget: TransferCandidate): boolean => {
  const required = ['id', 'name']

  required.forEach(field => {
    if (!budget[field as keyof TransferCandidate]) {
      throw new Error(`Missing field: ${field}`)
    }
  })

  return true
}

/**
 * Validates budget has positions
 * @param budget - Budget to validate
 * @returns True if has positions
 * @throws Error if no positions
 */
export const validateBudgetHasPositions = (budget: TransferCandidate): boolean => {
  if (budget.budget_positions.length === 0) {
    throw new Error('Budget has no positions')
  }
  return true
}

/**
 * Validates budget has phases
 * @param budget - Budget to validate
 * @returns True if has phases
 * @throws Error if no phases
 */
export const validateBudgetHasPhases = (budget: TransferCandidate): boolean => {
  if (budget.phases.length === 0) {
    throw new Error('Budget has no phases')
  }
  return true
}

/**
 * Validates all budget requirements
 * @param budget - Budget to validate
 * @returns True if valid
 * @throws Error on first validation failure
 */
export const validateBudget = (budget: TransferCandidate): boolean => {
  validateBudgetFields(budget)
  validateBudgetHasPositions(budget)
  validateBudgetHasPhases(budget)
  return true
}
